<script setup lang="ts">
import { useSuperAdministration } from "~/modules/superAdministration/composables/useSuperAdministration";
import { PATH_SUPER_ADMINISTRATION_SETTINGS } from "~/modules/superAdministration/constants";
import ILxcSettings from "~icons/lxc/settings";

const router = useRouter();
const { t } = useI18n();
const { isLoading, error, superAdministrationName, getSuperAdministration } =
  useSuperAdministration();

const onClickSettingsButton = () => {
  router.push(PATH_SUPER_ADMINISTRATION_SETTINGS);
};

getSuperAdministration();
</script>

<template>
  <page-component
    :breadcrumbs="[{ title: superAdministrationName }]"
    :is-loading="isLoading"
    :error="error"
  >
    <template #subtitle>
      <lxc-button
        v-if="!isLoading"
        :title="t('administration.superAdministration.settings.button')"
        type="borderless"
        class="!px-0 !py-0 ml-4"
        :icon="ILxcSettings"
        icon-class="!w-6 h-6"
        @click="onClickSettingsButton"
      />
    </template>
    <business-unit-card-list />
  </page-component>
</template>
